import { useEffect } from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import Button from 'components/button/Button';

import {
  ROUTE_SETTINGS_USERS_ADD,
  ROUTE_SETTINGS_USERS_USER,
  ROUTE_SETTINGS_ENTITY
} from 'routes/RouteList';
import { FormattedMessage } from 'react-intl';
import messages from 'messages';
import Icon from 'components/icon/Icon';
import Breadcrumbs from 'components/breadcrumbs/Breadcrumbs';
import Breadcrumb from 'components/breadcrumbs/Breadcrumb';
import Loader from 'components/loader/Loader';
import MessageText from 'components/message/MessageText';
import Message from 'components/message/Message';
import VirtualizedEntityList from 'containers/pages/persons/VirtualizedEntityList';
import { useAbility } from '@casl/react';
import { AbilityContext } from 'Can';
import usePersonStatus from 'hooks/utils/usePersonStatus';
import useFetchAndFilterUsers from 'hooks/queries/useFetchAndFilterUsers';
import { useEntityContext } from 'containers/pages/persons/store/useEntityContext';
import {
  Panel,
  PanelHeader,
  PanelSubtitle,
  PanelTitle,
  PanelTitleWrapper,
  PanelTools
} from 'components/panel';

const Users = () => {
  const ability = useAbility(AbilityContext);
  const { push } = useHistory();
  const { entityId, userId } = useParams();
  const { personStatusHandler } = usePersonStatus(entityId);

  const { loading, error, fetchUsers } = useFetchAndFilterUsers({
    entityId
  });
  const users = useEntityContext(s => s.persons);

  useEffect(() => {
    if (entityId) {
      fetchUsers(entityId);
    }
  }, [entityId]);

  return (
    <Panel>
      <PanelHeader borderBottom extraClassNames="u-margin-bottom-none">
        <Breadcrumbs>
          <Breadcrumb
            onClick={() =>
              push(generatePath(ROUTE_SETTINGS_ENTITY, { entityId }))
            }
          >
            <FormattedMessage {...messages.breadcrumbSettings} />
          </Breadcrumb>
        </Breadcrumbs>
        <PanelTitleWrapper>
          <PanelTitle>
            <FormattedMessage {...messages.titleUsers} />
          </PanelTitle>
          <PanelSubtitle>
            <FormattedMessage {...messages.subtitleUsers} />
          </PanelSubtitle>
        </PanelTitleWrapper>
        <PanelTools extraClassNames="u-margin-bottom-none">
          {ability.can('create', 'Users') && (
            <Button
              rounded
              primary
              onClick={() =>
                push(
                  generatePath(ROUTE_SETTINGS_USERS_ADD, {
                    entityId
                  })
                )
              }
            >
              <Icon id="add-white" />
              <FormattedMessage {...messages.buttonUsersAddUser} />
            </Button>
          )}
        </PanelTools>
      </PanelHeader>
      {loading && <Loader />}
      {error && <p>Error! {error.message}</p>}
      {!loading && (
        <>
          {users.length > 0 ? (
            <VirtualizedEntityList
              id={'settings'}
              items={users}
              activeId={userId}
              enableSelectAll={false}
              extraClassNames="u-padding-top-medium"
              showPersonStatus
              onClick={person => {
                push(
                  generatePath(ROUTE_SETTINGS_USERS_USER, {
                    entityId,
                    userId: person.id
                  })
                );
              }}
              onClickPersonStatus={personStatusHandler}
            />
          ) : (
            <Message emptyState icon="sporters">
              <MessageText>
                <FormattedMessage {...messages.noUsersAddedMessage} />
              </MessageText>
            </Message>
          )}
        </>
      )}
    </Panel>
  );
};

export default Users;
